import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import styled from "styled-components";
import { formatAmount } from "../../utills/formatNumber";

const P = styled.p`
  font-size: 14px;
  color: #333265;
  margin-bottom: 15px;
`;

const PnlTables = ({ pnlIncome, pnlExpenses }) => {
  const total = pnlIncome.data?.income_sum;
  const totalExpenses = pnlExpenses.data?.expense_sum;

  console.log(total, totalExpenses);
  

  return (
    <div>
      <P>Total Income: ₦{formatAmount(total)}</P>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow style={{ backgroundColor: "#f3f2f7" }}>
              <TableCell style={{ color: "#8281cc", fontWeight: "bold" }}>
                Name
              </TableCell>
              <TableCell style={{ color: "#8281cc", fontWeight: "bold" }}>
                Amount
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pnlIncome &&
              pnlIncome?.data?.income_gls.map((row, index) => (
                <TableRow
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#f3f2f7" : "#ffffff",
                  }}
                >
                  <TableCell style={{ color: "#8887a9" }}>{row?.gl}</TableCell>
                  <TableCell style={{ color: "#8887a9" }}>
                    {row?.gl_sum || "0.00"}
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        {/* Expenses */}

        <P style={{ marginTop: "30px" }}>
          Total Expenses: ₦{formatAmount(totalExpenses)}{" "}
        </P>
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow style={{ backgroundColor: "#f3f2f7" }}>
                <TableCell style={{ color: "#8281cc", fontWeight: "bold" }}>
                  Name
                </TableCell>
                <TableCell style={{ color: "#8281cc", fontWeight: "bold" }}>
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pnlExpenses &&
                pnlExpenses?.data?.expense_gls?.map((row, index) => (
                  <TableRow
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#f3f2f7" : "#ffffff",
                    }}
                  >
                    <TableCell style={{ color: "#8887a9" }}>
                      {row?.gl}
                    </TableCell>
                    <TableCell style={{ color: "#8887a9" }}>
                      {row?.gl_sum || "0.00"}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <P style={{ margin: "20px 0" }}>
            Net Income: ₦{formatAmount(totalExpenses - total)}
          </P>
        </TableContainer>
      </TableContainer>
    </div>
  );
};

export default PnlTables;
